<template>
     <v-row>
    <v-col>
  <v-container fluid>
    <v-row>
      <v-col class="d-flex flex-row align-center">
        <v-btn text @click="()=>{this.$router.go(-1)}"><v-icon dark>mdi-arrow-left</v-icon></v-btn>
        <h1>Admin Utilities</h1>
        <v-progress-circular
            indeterminate
            color="green"
            v-if="dataLoader"
            style="margin-left: 10px;"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-btn @click="openRebootDialog">Reboot System</v-btn>
      </v-col>
      <v-col cols="12" md="6">
        <confirmedActionButton xlarge @cb="updateBanner" requirePassword requireUsername buttonText="Send Banner" :dialogText="'Are you sure you wish to proceed?'" />
      </v-col>
    </v-row>
    <v-dialog
      v-model="rebootDialog.isOpen"
      width="600px"
    >
      <v-card>
        <v-card-title class="text-h5">Confirm Reboot System</v-card-title>
        <v-card-text>
          <v-text-field v-model="rebootDialog.password" label="Password" type="password" outlined></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" :disabled="!rebootDialog.password" text @click="initiateRebootSequence">Confirm Reboot</v-btn>
          <v-btn color="primary" text @click="closeRebootDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
    </v-col>
   </v-row>
</template>
<script>
import { mapGetters } from 'vuex'
import confirmedActionButton from '../../components/confirmedActionButton.vue';
import axios from "axios";

export default {
  components: {
    confirmedActionButton
  },
  name: 'Home',
  data () {
    return {
      dataLoader: false,
      formLoader: false,

      isEditable: false,
      isCreate: true,

      requiredRules: [
        v => !!v || 'Field is required.'
      ],

      data: [],
      form: {},
      validForm: false,

      rebootDialog: {
        isOpen: false,
        loading: false,
        password: ''
      },

      headers: [
        { text: 'Key', align: 'start', value: 'key' },
        { text: 'Value', value: 'value' }
      ]
    }
  },
  computed: {
    ...mapGetters(['getEndpoint'])
  },
  async mounted(){
    try {
      this.dataLoader = true;
      axios;
    } finally {
      this.dataLoader = false;
    }
  },
  methods: {

    async updateBanner(auth){
      let obj = {}
      obj.username = auth.username
      obj.password = auth.password
      await axios.post(`${this.getEndpoint}/api/utilities/reloadBanner`, obj)
      this.$snack("Done!")
    },
    openRebootDialog(){
      this.rebootDialog.isOpen = true
    },
    closeRebootDialog(){
      this.rebootDialog = {
        isOpen: false,
        loading: false,
        password: ''
      }
    },
    async initiateRebootSequence(){
      await axios.post(`${this.getEndpoint}/api/utilities/reboot`, {pin: this.rebootDialog.password})
      this.$snack("System Rebooting.")
      this.closeRebootDialog()
    }
  }
}
</script>
